import React from "react";
import {actions, Control, Errors, Form} from "react-redux-form";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

class ConfirmationForm extends React.Component {
    render() {
        return (
            <Form model={this.props.model} onSubmit={this.props.onSubmit}>
                <Errors model=".reset_password_token" wrapper={(props) => <p className='text-danger'>{props.children}</p>} component={(props) => <span>Reset password token {props.children}</span>}/>
                <div className='form-group'>
                    <label>Email</label>
                    <Control.text model='.email' className='form-control' onChange={() => { this.props.setValidity(this.props.model+'.email', true); }}/>
                    <Errors model=".email" className='text-danger form-text small'/>
                </div>
                <div className='separate'>
                    <button type='submit' className='btn btn-primary'>Odeslat</button>
                </div>
            </Form>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        setValidity: actions.setValidity
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ConfirmationForm);
